import React, { useId } from "react";
import { Button, Modal } from "react-bootstrap";
import "./security.css";

const ConfirmActionModal = ({ open, title, body, confirmLabel, onConfirm, onCancel }) => {
  const titleId = useId();
  return (
    <Modal show={open} animation={false} onHide={onCancel} aria-labelledby={titleId} className="mfa-modal">
      <Modal.Header><Modal.Title id={titleId}>{title}</Modal.Title></Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" className="mfa-btn-quiet" type="button" onClick={onCancel}>Cancel</Button>
        <Button type="button" className="text-white fw-bold" onClick={onConfirm}>{confirmLabel}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmActionModal;
